import classNames from 'classnames';

import { ResponsiveFrame, Skeleton } from '@jsmdg/yoshi';
import { SkeletonAnimation, SkeletonVariant } from '@jsmdg/yoshi/dist/enums/skeleton';
import styles from './SkeletonTile.module.scss';

const SkeletonTile = (): JSX.Element => {
    return (
        <div className="w-100 h-100 d-flex flex-column mx-1x">
            <div className="d-none d-sm-block">
                <ResponsiveFrame width={255} height={155}>
                    <div className="w-100 h-100">
                        <Skeleton
                            animation={SkeletonAnimation.Wave}
                            variant={SkeletonVariant.Rect}
                            width="100%"
                            height="100%"
                        />
                    </div>
                </ResponsiveFrame>

                <Skeleton
                    animation={SkeletonAnimation.Wave}
                    variant={SkeletonVariant.Text}
                    className={classNames(styles.w30, 'mt-1x')}
                />
                <Skeleton
                    animation={SkeletonAnimation.Wave}
                    variant={SkeletonVariant.Text}
                    className="w-100 mt-1-5x"
                    height={50}
                />
                <Skeleton
                    animation={SkeletonAnimation.Wave}
                    variant={SkeletonVariant.Text}
                    className={classNames(styles.w30, 'mt-2x')}
                    height={22}
                />
            </div>

            <div className="d-sm-none">
                <ResponsiveFrame width={255} height={130}>
                    <div className="w-100 h-100">
                        <Skeleton
                            animation={SkeletonAnimation.Wave}
                            variant={SkeletonVariant.Rect}
                            width="100%"
                            height="100%"
                        />
                    </div>
                </ResponsiveFrame>
                <Skeleton
                    animation={SkeletonAnimation.Wave}
                    variant={SkeletonVariant.Text}
                    className={classNames(styles.w30, 'mt-0-5x')}
                />
                <Skeleton
                    animation={SkeletonAnimation.Wave}
                    variant={SkeletonVariant.Text}
                    className="w-100 mt-1x"
                />
                <Skeleton
                    animation={SkeletonAnimation.Wave}
                    variant={SkeletonVariant.Text}
                    className={classNames(styles.w30, 'mt-2x')}
                />
            </div>
        </div>
    );
};

export { SkeletonTile };
